export default {
  page: 0,
  isFull: false,
  isLoaded: true,
  items: [],
  notFetchedById: [],
  error: null,
};
